import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Input,
  Rate,
  Select,
  Spin,
  Switch,
} from "antd";
import {
  EditOutlined,
  WarningOutlined,
  CheckOutlined,
  CloseOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  getPage,
  getParamValue,
  jcTypeArray,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import Loader from "../common/Loader";
import LoaderFull from "../common/LoaderFull";
const { Option } = Select;

const ShopsList = ({
  inHub = false,
  inMerchant = false,
  inMerchantId,
  activeSearch = true,
  loading,
}: {
  inHub?: boolean;
  inMerchant?: boolean;
  inMerchantId?: any;
  activeSearch?: boolean;
  loading?: boolean;
}) => {
  const fetchRef = useRef(0);
  const history = useHistory();
  const route = useParams();
  const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [shopOptions, setShopOptions] = useState({ loading: false, list: [] });
  const [key, setKey] = useState("");
  const [selectedShop, setSelectedShop] = useState(undefined);
  const [selectedShopForEdit, setSelectedShopForEdit] = useState(undefined);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [hubId, setHubId] = useState<any>();
  const [merchantId, setMerchantId] = useState<any>();
  const [isActive, setIsActive] = useState<any>(undefined);

  const [shopData, setShopData] = useState({
    loading: false,
    data: null,
  });

  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [merchantOptions, setMerchantOptions] = useState<any>({
    loading: false,
    list: [],
  });

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const isDeleted = "false";

  const getShops = useCallback(
    async (getId) => {
      setShopData({ loading: true, data: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      if (inHub) {
        axios
          .get(
            `${encodedUri}/hub/shops?page=${page || 0}&limit=${limit || 16}` +
              (type ? `&type=${type}` : ``) +
              (getId ? `&id=${getId || (route as any)?.hubId}` : ``) +
              (key ? `&name=${key}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setShopData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setShopData({ loading: false, data: [] });
            console.error("Shop: Error", err);
          });
      } else if (inMerchant) {
        axios
          .get(
            `${encodedUri}/admin/shop/by-merchant?page=${page || 0}&limit=${
              limit || 16
            }&merchantId=${inMerchantId}` +
              // (type ? `&type=${type}` : ``) +
              (status ? `&status=${status}` : ``) +
              (key ? `&key=${key}` : ``) +
              (merchantId ? `&merchantId=${merchantId}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setShopData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setShopData({ loading: false, data: [] });
            console.error("Shop: Error", err);
          });
      } else {
        axios
          .get(
            `${encodedUri}/admin/shop/v2?page=${page || 0}&limit=${
              limit || 16
            }` +
              (type ? `&type=${type}` : ``) +
              (status ? `&status=${status}` : ``) +
              (key ? `&key=${key}` : ``) +
              (isActive ? `&isActive=${isActive}` : ``) +
              (isDeleted ? `&isDeleted=${isDeleted}` : ``) +
              (hubId ? `&hubId=${hubId}` : ``) +
              (merchantId ? `&merchantId=${merchantId}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          )
          .then((res) => {
            setShopData({ loading: false, data: res.data });
          })
          .catch((err) => {
            setShopData({ loading: false, data: [] });
            console.error("Shop: Error", err);
          });
      }
    },
    [page, limit, type, status, key, hubId, merchantId, isActive, isDeleted]
  );

  const getShopOptions = useCallback(
    async (key) => {
      setShopOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      return axios
        .get(
          `${encodedUri}/shop/admin/search?page=0&limit=20` +
            (key ? `&key=${key}` : ``) +
            (type ? `&type=${type}` : ``) +
            (inHub ? `&hubId=${(route as any)?.hubId}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setShopOptions({
            loading: false,
            list: res.data?.shops?.map((shop) => ({
              label: shop.name,
              value: shop.name,
            })),
          });
        })
        .catch((err) => {
          setShopOptions({ loading: false, list: [] });
          console.error("Categories: Error", err);
        });
    },
    [inHub, route, type]
  );

  const getMerchantsOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/merchant/all?page=0&limit=20` +
          (type ? `&serviceType=${type}` : ``) +
          (key ? `&name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setMerchantOptions({
        loading: false,
        list: res.data?.merchants?.map((merchant) => ({
          label: merchant.fullName || merchant.mobileNumber?.split("+88"),
          value: merchant.id,
        })),
      });
    },
    [type]
  );

  const getHubsOptions = useCallback(
    async (val?: string) => {
      setHubsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setHubsOptions({
        loading: false,
        list: res?.data?.hub?.map((hub) => {
          return {
            id: hub?.id,
            name: hub?.name,
          };
        }),
      });
    },
    [type]
  );

  const onStatusChange = async (id, val) => {
    setConfirmLoading(id);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setConfirmLoading(undefined);
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getShops("");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  //
  // const onDelete = async (id, val) => {
  //   setConfirmLoading(id);
  //   if (id) {
  //     await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/shop`, {
  //       method: "PUT",
  //       headers: {
  //         Authorization: `Bearer ${authenticateToken()}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         id: id,
  //         deleted: !val,
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((res) => {
  //         setConfirmLoading(undefined);
  //         if (res.statusCode === 200) {
  //           responseNotification("Status Updated Successfully", "success");
  //           getShops("");
  //         } else if (res.status === 500) {
  //           responseNotification("Internal server error", "error");
  //         } else {
  //           responseNotification(res.message || "something wrong", "warning");
  //         }
  //       })
  //       .catch((err) => {
  //         responseNotification(`${"Internal server error"} ${err}`, "error");
  //         console.error("err", err);
  //       });
  //   }
  // };
  //

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "hub") getHubsOptions(value);
        if (field === "merchant") getMerchantsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getHubsOptions, getMerchantsOptions]);

  useEffect(() => {
    getShops((route as any).hubId);
  }, [getShops, route]);

  useEffect(() => {
    if (type) {
      getMerchantsOptions();
    }
  }, [type]);

  useEffect(() => {
    if (activeSearch) {
      setSelectedShop(undefined);
      setSelectedShopForEdit(undefined);
    }
  }, [selectedShop, selectedShopForEdit, visible]);

  useEffect(() => {
    setSelectedShop(undefined);
    setSelectedShopForEdit(undefined);
    getHubsOptions();
    getMerchantsOptions();
  }, [visible]);

  const debounceShopOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getShopOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getShopOptions]);

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setHubId("");
    setIsActive("");
    setType("JC_MART");
    form.resetFields();
  };

  if (loading) return <Loader />;

  return (
    <React.Fragment>
      {!inHub && !inMerchant && (
        <TopHeading total={shopData?.data?.totalElements} refetch={getShops} />
      )}
      {activeSearch && (
        <>
          <section className="search_area">
            <Form form={form} className="search_form">
              {!inHub && (
                <>
                  <Form.Item initialValue={type}>
                    <Select
                      placeholder="Shop Type"
                      onChange={(val) => setType(val)}
                      value={type}
                      style={{ width: 250 }}
                    >
                      {Object.values(jcTypeArray)?.map((type, i) => (
                        <Option value={type} key={i}>
                          {type.replace("_", " ")}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item name="search">
                    <AutoComplete
                      style={{ width: 300 }}
                      onSearch={debounceShopOptionsFetcher}
                      onSelect={(val) => setKey(val.toString())}
                      options={shopOptions?.list}
                      defaultActiveFirstOption={false}
                      notFoundContent={
                        shopOptions?.loading ? <Spin size="small" /> : null
                      }
                    >
                      <Input.Search
                        placeholder="Search by Name"
                        onSearch={(val) => setKey(val)}
                        enterButton
                        loading={shopOptions.loading}
                      />
                    </AutoComplete>
                  </Form.Item>

                  <Form.Item name="hub_search">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Filter by Hub"
                      optionFilterProp="children"
                      onChange={(val) => setHubId(val)}
                      onSearch={(e) => handleSearch(e, "hub")}
                      filterOption={(input, option) =>
                        option.children
                          .toString()
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {hubsOptions.list.length ? (
                        <Option value={""}>All Hubs</Option>
                      ) : undefined}
                      {hubsOptions.list.map((hub) => (
                        <Option value={hub.id} key={hub.id}>
                          {hub.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              )}

              <Form.Item name="merchant_search">
                <Select
                  allowClear
                  showSearch
                  placeholder="Filter by Merchant"
                  optionFilterProp="children"
                  onChange={(val) => setMerchantId(val)}
                  onSearch={(e) => handleSearch(e, "merchant")}
                  filterOption={() => {
                    return true;
                  }}
                  options={merchantOptions.list}
                ></Select>
              </Form.Item>

              <Form.Item
                name="deleted_search"
                initialValue={
                  isActive == "true"
                    ? "ACTIVE"
                    : isActive == "false"
                    ? "INACTIVE"
                    : "ALL"
                }
              >
                <Select
                  showSearch
                  placeholder="Status"
                  onChange={(val) => setIsActive(val as string)}
                >
                  <Select.Option value={undefined}>ALL</Select.Option>
                  <Select.Option value={"true"} title="ACTIVE">
                    ACTIVE
                  </Select.Option>
                  <Select.Option value={"false"} title="INACTIVE">
                    INACTIVE
                  </Select.Option>
                </Select>
              </Form.Item>
            </Form>
            <div className="search_btn">
              <Button
                type="primary"
                danger
                size="large"
                onClick={reseAllFieldData}
              >
                Reset
              </Button>
            </div>
          </section>
        </>
      )}

      {confirmLoading && <LoaderFull />}

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Shop Name</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Hub</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Ratting</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {shopData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {shopData?.data?.shops?.length ? (
                    shopData?.data?.shops?.map((shop, index) => (
                      <React.Fragment key={index}>
                        <Link
                          to={
                            inHub
                              ? `/hubs/${(route as any).hubId}/shop/${shop?.id}`
                              : `/shops/${shop?.id}/details`
                          }
                          target="_blank"
                        >
                          <div className="single-product-wrapper">
                            <div className="single-product major">
                              <Avatar
                                shape="circle"
                                size={45}
                                src={getImgUrl(shop?.logo)}
                                className="mr-3"
                              />
                              <span className="name">
                                {shop?.name?.toUpperCase()}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {shop?.type?.replace("_", " ")}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">{shop?.hub?.name}</span>
                            </div>

                            <div className="single-product">
                              <span className="name d-flex-l">
                                {shop?.numberOfRating ? (
                                  <Rate value={shop?.rating || 0} disabled />
                                ) : (
                                  <Rate value={0} disabled />
                                )}
                                {shop?.numberOfRating ? (
                                  <small className="ml-1">
                                    ({shop?.numberOfRating})
                                  </small>
                                ) : undefined}
                              </span>
                            </div>

                            <div className="single-product">
                              <span
                                className={`d-flex align-items-center radius-btn text-uppercase ${shop?.status?.toLowerCase()}-btn`}
                              >
                                {shop?.status?.toUpperCase() === "OPEN" ? (
                                  <CheckOutlined className="mr-1" />
                                ) : shop?.status?.toUpperCase() === "BUSY" ? (
                                  <WarningOutlined className="mr-1" />
                                ) : (
                                  <CloseOutlined className="mr-1" />
                                )}
                                {shop?.status?.split("_").join(" ")}
                              </span>
                            </div>

                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={shop?.isActive}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  onStatusChange(shop?.id, val);
                                }}
                                className="mr-1"
                                loading={
                                  confirmLoading && shop?.id === confirmLoading
                                }
                                disabled={shop?.hub?.deleted}
                              />

                              {inHub && (
                                <>
                                  <Button
                                    title="Manage Shop"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      history.push(
                                        `/shops/${shop?.id}/details`
                                      );
                                    }}
                                    target="_blank"
                                  >
                                    <SettingOutlined />
                                  </Button>

                                  {/* <Popconfirm
                                    placement="left"
                                    title="Are you sure to delete?"
                                    visible={shop?.id === visible}
                                    okButtonProps={{ loading: confirmLoading }}
                                    onCancel={(e) => {
                                      e.preventDefault();
                                      handleCancel();
                                    }}
                                    onConfirm={(e) => {
                                      e.preventDefault();
                                      onUnlinkFromHub(shop?.id);
                                    }}
                                  >
                                    <Button
                                      title="Unlink/Remove"
                                      type="primary"
                                      danger
                                      className="mx-1"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        showPopconfirm(shop?.id);
                                      }}
                                      // disabled={shop?.deleted === true}
                                    >
                                      <ApiOutlined />
                                    </Button>
                                  </Popconfirm> */}
                                </>
                              )}

                              {!inHub && (
                                <Link
                                  className="btn btn-sm btn-warning mx-1"
                                  to={`/shops/${shop?.id}/edit`}
                                >
                                  <EditOutlined />
                                </Link>
                              )}
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="shops" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...shopData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShopsList;
